export default __webpack_public_path__ + "2b327bda75ccb4c9c3cd7ea61c4fed82.svg";